// Components
import EditRejectPageTemplate, { EditRejectPageTemplateProps } from "components/organisms/EditRejectPageTemplate/EditRejectPageTemplate";

// Modules
import { useMonthlyReimbursementRejectPage } from "containers/MonthlyDeclaration/RejectReimbursement/useMonthlyReimbursementRejectPage";

// Constants
import { REJECT_MONTHLY_REIMBURSEMENT as Constants, FILE_UPLOAD_CONSTANT } from "constants/global";

const MonthlyReimbursementRejectPage = (): JSX.Element => {
	const { submissionLoading, inputFields, isNextEnabled, goBack, fieldErrors, handleFileUpload, handleTextAreaChange, handleInputChange, handleSubmit } =
		useMonthlyReimbursementRejectPage();

	const MonthlyReimbursementRejectPageProps: EditRejectPageTemplateProps = {
		stepsInfo: Constants.STEPS_INFO,
		headTitle: Constants.HEAD_TITLE,
		pageTitle: Constants.PAGE_TITLE,
		pageSubTitle: Constants.PAGE_SUBTITLE,
		uploadFileTypes: FILE_UPLOAD_CONSTANT.REJECT_MONTHLY_REIMBURSMENT_FILETYPE,
		operationType: "reject",
		inputFields: inputFields,
		isNextEnabled,
		submissionLoading,
		pageGoBack: goBack,
		fieldErrors,
		handleFileUpload,
		handleTextAreaChange,
		handleInputChange,
		handleSubmit
	};

	return <EditRejectPageTemplate {...MonthlyReimbursementRejectPageProps} />;
};

export default MonthlyReimbursementRejectPage;
